import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeft, FileText } from 'lucide-react';
export function TermsRestaurantsPage() {
  return <div className="min-h-screen bg-[#0B0B0B] text-white selection:bg-[#006847] selection:text-white" data-id="element-5986">
      {/* Header */}
      <header className="sticky top-0 z-50 bg-[#0B0B0B]/80 backdrop-blur-md border-b border-white/10" data-id="element-5987">
        <div className="max-w-4xl mx-auto px-6 h-16 flex items-center justify-between" data-id="element-5988">
          <Link to="/" className="flex items-center gap-2 text-white/60 hover:text-white transition-colors text-sm font-medium" data-id="element-5989">
            <ArrowLeft className="w-4 h-4" data-id="element-5990" />
            Volver
          </Link>
          <div className="font-black text-xl tracking-tight" data-id="element-5991">NOIZA</div>
          <div className="w-20" data-id="element-5992" /> {/* Spacer for centering */}
        </div>
      </header>

      {/* Content */}
      <main className="max-w-3xl mx-auto px-6 py-12 md:py-20" data-id="element-5993">
        <div className="mb-12" data-id="element-5994">
          <div className="w-12 h-12 bg-white/5 rounded-2xl flex items-center justify-center mb-6 border border-white/10" data-id="element-5995">
            <FileText className="w-6 h-6 text-white/80" data-id="element-5996" />
          </div>
          <h1 className="text-3xl md:text-4xl font-black mb-4 tracking-tight" data-id="element-5997">
            Términos y Condiciones para Restaurantes
          </h1>
          <p className="text-white/60 text-lg" data-id="element-5998">
            NOIZA – Plataforma Tecnológica y Marketplace Gastronómico
          </p>
        </div>

        <div className="space-y-12 text-white/80 leading-relaxed" data-id="element-5999">
          <section data-id="element-6000">
            <h2 className="text-xl font-bold text-white mb-4 flex items-baseline gap-3" data-id="element-6001">
              <span className="text-[#006847]" data-id="element-6002">1.</span>
              INTRODUCCIÓN Y ACEPTACIÓN
            </h2>
            <div className="space-y-4" data-id="element-6003">
              <p data-id="element-6004">
                Los presentes Términos y Condiciones regulan el acceso, uso y
                permanencia del restaurante dentro de la plataforma NOIZA, en
                adelante "la Plataforma".
              </p>
              <p data-id="element-6005">
                Al registrarse, acceder o utilizar cualquier funcionalidad de
                NOIZA, el restaurante declara:
              </p>
              <ul className="list-disc pl-6 space-y-2 text-white/70" data-id="element-6006">
                <li data-id="element-6007">Haber leído íntegramente este documento</li>
                <li data-id="element-6008">Comprender su contenido en su totalidad</li>
                <li data-id="element-6009">
                  Aceptar voluntaria e irrevocablemente todas sus condiciones
                </li>
              </ul>
              <p data-id="element-6010">
                En caso de no estar de acuerdo con alguno de los puntos
                establecidos, el restaurante deberá abstenerse de utilizar la
                Plataforma.
              </p>
            </div>
          </section>

          <section data-id="element-6011">
            <h2 className="text-xl font-bold text-white mb-4 flex items-baseline gap-3" data-id="element-6012">
              <span className="text-[#006847]" data-id="element-6013">2.</span>
              NATURALEZA DEL SERVICIO
            </h2>
            <div className="space-y-4" data-id="element-6014">
              <p data-id="element-6015">NOIZA es una solución tecnológica que combina:</p>
              <ul className="list-disc pl-6 space-y-2 text-white/70" data-id="element-6016">
                <li data-id="element-6017">Software como servicio (SaaS)</li>
                <li data-id="element-6018">Marketplace digital gastronómico</li>
                <li data-id="element-6019">Herramientas de gestión operativa para restaurantes</li>
              </ul>
              <p data-id="element-6020">La Plataforma permite a los restaurantes:</p>
              <ul className="list-disc pl-6 space-y-2 text-white/70" data-id="element-6021">
                <li data-id="element-6022">Mostrar su menú digital</li>
                <li data-id="element-6023">Recibir pedidos de clientes</li>
                <li data-id="element-6024">Gestionar su operación interna</li>
                <li data-id="element-6025">
                  Facilitar la comunicación directa con el cliente
                  (principalmente vía WhatsApp)
                </li>
              </ul>
              <p className="font-medium text-white" data-id="element-6026">
                NOIZA actúa únicamente como un facilitador tecnológico.
              </p>
            </div>
          </section>

          <section data-id="element-6027">
            <h2 className="text-xl font-bold text-white mb-4 flex items-baseline gap-3" data-id="element-6028">
              <span className="text-[#006847]" data-id="element-6029">3.</span>
              DECLARACIÓN EXPRESA DE NO INTERMEDIACIÓN
            </h2>
            <div className="space-y-4" data-id="element-6030">
              <p data-id="element-6031">El restaurante reconoce expresamente que NOIZA:</p>
              <ul className="list-disc pl-6 space-y-2 text-white/70" data-id="element-6032">
                <li data-id="element-6033">No es proveedor de alimentos</li>
                <li data-id="element-6034">No participa en la preparación de productos</li>
                <li data-id="element-6035">No manipula alimentos en ningún momento</li>
                <li data-id="element-6036">No realiza entregas ni logística</li>
                <li data-id="element-6037">No procesa pagos en nombre del restaurante</li>
                <li data-id="element-6038">No actúa como representante comercial del restaurante</li>
              </ul>
              <p data-id="element-6039">
                La Plataforma se limita a proporcionar herramientas digitales
                para facilitar la interacción entre el restaurante y el cliente
                final.
              </p>
            </div>
          </section>

          <section data-id="element-6040">
            <h2 className="text-xl font-bold text-white mb-4 flex items-baseline gap-3" data-id="element-6041">
              <span className="text-[#006847]" data-id="element-6042">4.</span>
              INDEPENDENCIA DEL RESTAURANTE
            </h2>
            <div className="space-y-4" data-id="element-6043">
              <p data-id="element-6044">
                Cada restaurante que utiliza NOIZA opera como una entidad
                completamente independiente.
              </p>
              <p data-id="element-6045">Esto implica que:</p>
              <ul className="list-disc pl-6 space-y-2 text-white/70" data-id="element-6046">
                <li data-id="element-6047">El restaurante es el único responsable de su operación</li>
                <li data-id="element-6048">
                  No existe relación laboral, societaria o de representación con
                  NOIZA
                </li>
                <li data-id="element-6049">
                  NOIZA no ejerce control sobre las decisiones del restaurante
                </li>
              </ul>
              <p data-id="element-6050">El restaurante mantiene total autonomía en:</p>
              <ul className="list-disc pl-6 space-y-2 text-white/70" data-id="element-6051">
                <li data-id="element-6052">Precios</li>
                <li data-id="element-6053">Menú</li>
                <li data-id="element-6054">Horarios</li>
                <li data-id="element-6055">Métodos de pago</li>
                <li data-id="element-6056">Procesos internos</li>
              </ul>
            </div>
          </section>

          <section data-id="element-6057">
            <h2 className="text-xl font-bold text-white mb-4 flex items-baseline gap-3" data-id="element-6058">
              <span className="text-[#006847]" data-id="element-6059">5.</span>
              EXCLUSIÓN TOTAL DE RESPONSABILIDAD
            </h2>

            <div className="space-y-8" data-id="element-6060">
              <div data-id="element-6061">
                <h3 className="text-lg font-semibold text-white mb-2" data-id="element-6062">
                  5.1. Alcance general
                </h3>
                <p data-id="element-6063">
                  El restaurante acepta que NOIZA queda exento de cualquier tipo
                  de responsabilidad, directa o indirecta, derivada de la
                  operación del restaurante.
                </p>
              </div>

              <div data-id="element-6064">
                <h3 className="text-lg font-semibold text-white mb-2" data-id="element-6065">
                  5.2. Alimentos y calidad del servicio
                </h3>
                <p className="mb-2" data-id="element-6066">NOIZA no será responsable por:</p>
                <ul className="list-disc pl-6 space-y-1 text-white/70 mb-2" data-id="element-6067">
                  <li data-id="element-6068">Calidad de los alimentos</li>
                  <li data-id="element-6069">Estado, frescura o preparación</li>
                  <li data-id="element-6070">Ingredientes utilizados</li>
                  <li data-id="element-6071">Contaminación cruzada</li>
                  <li data-id="element-6072">Problemas de higiene o salubridad</li>
                  <li data-id="element-6073">Reacciones alérgicas</li>
                </ul>
                <p className="font-medium text-white" data-id="element-6074">
                  Toda responsabilidad recae exclusivamente en el restaurante.
                </p>
              </div>

              <div data-id="element-6075">
                <h3 className="text-lg font-semibold text-white mb-2" data-id="element-6076">
                  5.3. Entregas y logística
                </h3>
                <p className="mb-2" data-id="element-6077">
                  NOIZA no participa ni interviene en la entrega de pedidos. Por
                  lo tanto, NOIZA no será responsable por:
                </p>
                <ul className="list-disc pl-6 space-y-1 text-white/70" data-id="element-6078">
                  <li data-id="element-6079">Retrasos en la entrega</li>
                  <li data-id="element-6080">Pérdida de pedidos</li>
                  <li data-id="element-6081">Entregas incompletas</li>
                  <li data-id="element-6082">Errores en dirección</li>
                  <li data-id="element-6083">Conducta de repartidores</li>
                  <li data-id="element-6084">Daños durante el transporte</li>
                </ul>
              </div>

              <div data-id="element-6085">
                <h3 className="text-lg font-semibold text-white mb-2" data-id="element-6086">
                  5.4. Pagos
                </h3>
                <p className="mb-2" data-id="element-6087">
                  NOIZA no procesa ni administra pagos. El restaurante es el
                  único responsable de:
                </p>
                <ul className="list-disc pl-6 space-y-1 text-white/70 mb-4" data-id="element-6088">
                  <li data-id="element-6089">Recepción de pagos</li>
                  <li data-id="element-6090">Validación de transferencias (incluyendo SINPE)</li>
                  <li data-id="element-6091">Manejo de efectivo</li>
                  <li data-id="element-6092">Confirmación de pagos</li>
                  <li data-id="element-6093">Prevención de fraudes</li>
                </ul>
                <p className="mb-2" data-id="element-6094">NOIZA no será responsable por:</p>
                <ul className="list-disc pl-6 space-y-1 text-white/70" data-id="element-6095">
                  <li data-id="element-6096">Pagos no recibidos</li>
                  <li data-id="element-6097">Comprobantes falsos</li>
                  <li data-id="element-6098">Errores en montos</li>
                  <li data-id="element-6099">Estafas o fraudes de terceros</li>
                </ul>
              </div>

              <div data-id="element-6100">
                <h3 className="text-lg font-semibold text-white mb-2" data-id="element-6101">
                  5.5. Relación con clientes
                </h3>
                <p className="mb-2" data-id="element-6102">NOIZA no será responsable por:</p>
                <ul className="list-disc pl-6 space-y-1 text-white/70 mb-2" data-id="element-6103">
                  <li data-id="element-6104">Reclamos de clientes</li>
                  <li data-id="element-6105">Reembolsos</li>
                  <li data-id="element-6106">Cancelaciones</li>
                  <li data-id="element-6107">Disputas</li>
                  <li data-id="element-6108">Opiniones o reseñas</li>
                </ul>
                <p className="font-medium text-white" data-id="element-6109">
                  Toda relación comercial se da directamente entre el
                  restaurante y el cliente.
                </p>
              </div>
            </div>
          </section>

          <section data-id="element-6110">
            <h2 className="text-xl font-bold text-white mb-4 flex items-baseline gap-3" data-id="element-6111">
              <span className="text-[#006847]" data-id="element-6112">6.</span>
              USO DE LA PLATAFORMA
            </h2>
            <div className="space-y-4" data-id="element-6113">
              <p data-id="element-6114">El restaurante se compromete a utilizar NOIZA de forma:</p>
              <ul className="list-disc pl-6 space-y-1 text-white/70" data-id="element-6115">
                <li data-id="element-6116">Responsable</li>
                <li data-id="element-6117">Legal</li>
                <li data-id="element-6118">Transparente</li>
              </ul>
              <p className="mt-4" data-id="element-6119">Queda prohibido:</p>
              <ul className="list-disc pl-6 space-y-1 text-white/70" data-id="element-6120">
                <li data-id="element-6121">Publicar información falsa</li>
                <li data-id="element-6122">Manipular precios de forma engañosa</li>
                <li data-id="element-6123">Simular disponibilidad inexistente</li>
                <li data-id="element-6124">Utilizar la plataforma con fines fraudulentos</li>
              </ul>
            </div>
          </section>

          <section data-id="element-6125">
            <h2 className="text-xl font-bold text-white mb-4 flex items-baseline gap-3" data-id="element-6126">
              <span className="text-[#006847]" data-id="element-6127">7.</span>
              PROPIEDAD DEL MENÚ DIGITAL
            </h2>
            <div className="space-y-4" data-id="element-6128">
              <p data-id="element-6129">El menú digital creado dentro de NOIZA:</p>
              <ul className="list-disc pl-6 space-y-1 text-white/70" data-id="element-6130">
                <li data-id="element-6131">Pertenece al restaurante en términos de contenido</li>
                <li data-id="element-6132">
                  Puede ser utilizado por el restaurante fuera del marketplace
                </li>
              </ul>
              <p className="mt-4 font-medium text-white" data-id="element-6133">Condiciones:</p>
              <ul className="list-disc pl-6 space-y-2 text-white/70" data-id="element-6134">
                <li data-id="element-6135">
                  Si el restaurante mantiene una suscripción activa, el sistema
                  opera normalmente
                </li>
                <li data-id="element-6136">
                  Si no mantiene suscripción:
                  <ul className="list-circle pl-6 mt-2 space-y-1" data-id="element-6137">
                    <li data-id="element-6138">
                      Podrá seguir utilizando el sistema únicamente si cubre
                      costos asociados (hosting, dominio, etc.)
                    </li>
                    <li data-id="element-6139">NOIZA podrá limitar funcionalidades</li>
                  </ul>
                </li>
              </ul>
            </div>
          </section>

          <section data-id="element-6140">
            <h2 className="text-xl font-bold text-white mb-4 flex items-baseline gap-3" data-id="element-6141">
              <span className="text-[#006847]" data-id="element-6142">8.</span>
              SISTEMA SaaS
            </h2>
            <div className="space-y-4" data-id="element-6143">
              <p data-id="element-6144">NOIZA proporciona un sistema tecnológico que incluye:</p>
              <ul className="list-disc pl-6 space-y-1 text-white/70" data-id="element-6145">
                <li data-id="element-6146">Menú digital</li>
                <li data-id="element-6147">Gestión de pedidos</li>
                <li data-id="element-6148">Herramientas operativas</li>
              </ul>
              <div className="grid sm:grid-cols-2 gap-6 mt-6" data-id="element-6149">
                <div className="bg-white/5 p-4 rounded-xl border border-white/10" data-id="element-6150">
                  <p className="font-medium text-white mb-2" data-id="element-6151">
                    El restaurante recibe:
                  </p>
                  <ul className="list-disc pl-6 space-y-1 text-white/70" data-id="element-6152">
                    <li data-id="element-6153">Derecho de uso del sistema</li>
                  </ul>
                </div>
                <div className="bg-white/5 p-4 rounded-xl border border-white/10" data-id="element-6154">
                  <p className="font-medium text-white mb-2" data-id="element-6155">NO recibe:</p>
                  <ul className="list-disc pl-6 space-y-1 text-white/70" data-id="element-6156">
                    <li data-id="element-6157">Propiedad del software</li>
                    <li data-id="element-6158">Acceso al código fuente</li>
                  </ul>
                </div>
              </div>
              <p className="font-medium text-white mt-4" data-id="element-6159">
                NOIZA mantiene todos los derechos sobre la tecnología
                desarrollada.
              </p>
            </div>
          </section>

          <section data-id="element-6160">
            <h2 className="text-xl font-bold text-white mb-4 flex items-baseline gap-3" data-id="element-6161">
              <span className="text-[#006847]" data-id="element-6162">9.</span>
              DISPONIBILIDAD DEL SERVICIO
            </h2>
            <div className="space-y-4" data-id="element-6163">
              <p data-id="element-6164">NOIZA no garantiza:</p>
              <ul className="list-disc pl-6 space-y-1 text-white/70" data-id="element-6165">
                <li data-id="element-6166">Disponibilidad continua</li>
                <li data-id="element-6167">Funcionamiento sin interrupciones</li>
                <li data-id="element-6168">Ausencia total de errores</li>
              </ul>
              <p className="mt-4" data-id="element-6169">Pueden ocurrir:</p>
              <ul className="list-disc pl-6 space-y-1 text-white/70" data-id="element-6170">
                <li data-id="element-6171">Fallas técnicas</li>
                <li data-id="element-6172">Actualizaciones</li>
                <li data-id="element-6173">Mantenimientos</li>
              </ul>
              <p className="font-medium text-white mt-2" data-id="element-6174">
                NOIZA no será responsable por pérdidas derivadas de estos
                eventos.
              </p>
            </div>
          </section>

          <section data-id="element-6175">
            <h2 className="text-xl font-bold text-white mb-4 flex items-baseline gap-3" data-id="element-6176">
              <span className="text-[#006847]" data-id="element-6177">10.</span>
              VISIBILIDAD EN EL MARKETPLACE
            </h2>
            <div className="space-y-4" data-id="element-6178">
              <p data-id="element-6179">El restaurante acepta que su visibilidad dentro de NOIZA:</p>
              <ul className="list-disc pl-6 space-y-1 text-white/70" data-id="element-6180">
                <li data-id="element-6181">No está garantizada permanentemente</li>
                <li data-id="element-6182">Puede variar según criterios internos</li>
              </ul>
              <p className="mt-4" data-id="element-6183">NOIZA podrá:</p>
              <ul className="list-disc pl-6 space-y-1 text-white/70" data-id="element-6184">
                <li data-id="element-6185">Destacar o no restaurantes</li>
                <li data-id="element-6186">Modificar posiciones</li>
                <li data-id="element-6187">Aplicar filtros o algoritmos</li>
              </ul>
            </div>
          </section>

          <section data-id="element-6188">
            <h2 className="text-xl font-bold text-white mb-4 flex items-baseline gap-3" data-id="element-6189">
              <span className="text-[#006847]" data-id="element-6190">11.</span>
              PAGOS Y CONDICIONES ECONÓMICAS
            </h2>
            <div className="space-y-4" data-id="element-6191">
              <p data-id="element-6192">El restaurante se compromete a:</p>
              <ul className="list-disc pl-6 space-y-1 text-white/70" data-id="element-6193">
                <li data-id="element-6194">Cumplir con los pagos acordados</li>
                <li data-id="element-6195">Mantener su cuenta al día</li>
              </ul>
              <p className="mt-4" data-id="element-6196">En caso de incumplimiento, NOIZA podrá:</p>
              <ul className="list-disc pl-6 space-y-1 text-white/70" data-id="element-6197">
                <li data-id="element-6198">Suspender el servicio</li>
                <li data-id="element-6199">Limitar funcionalidades</li>
                <li data-id="element-6200">Retirar visibilidad</li>
              </ul>
            </div>
          </section>

          <section data-id="element-6201">
            <h2 className="text-xl font-bold text-white mb-4 flex items-baseline gap-3" data-id="element-6202">
              <span className="text-[#006847]" data-id="element-6203">12.</span>
              TERMINACIÓN
            </h2>
            <div className="space-y-4" data-id="element-6204">
              <p data-id="element-6205">NOIZA podrá suspender o terminar el acceso en caso de:</p>
              <ul className="list-disc pl-6 space-y-1 text-white/70" data-id="element-6206">
                <li data-id="element-6207">Incumplimiento de términos</li>
                <li data-id="element-6208">Uso indebido</li>
                <li data-id="element-6209">Conductas que afecten la plataforma</li>
              </ul>
              <p className="mt-2" data-id="element-6210">
                El restaurante podrá dejar de usar el servicio en cualquier
                momento.
              </p>
            </div>
          </section>

          <section data-id="element-6211">
            <h2 className="text-xl font-bold text-white mb-4 flex items-baseline gap-3" data-id="element-6212">
              <span className="text-[#006847]" data-id="element-6213">13.</span>
              MODIFICACIONES
            </h2>
            <div className="space-y-4" data-id="element-6214">
              <p data-id="element-6215">NOIZA podrá modificar estos términos en cualquier momento.</p>
              <p data-id="element-6216">El uso continuo implica aceptación automática de cambios.</p>
            </div>
          </section>

          <section data-id="element-6217">
            <h2 className="text-xl font-bold text-white mb-4 flex items-baseline gap-3" data-id="element-6218">
              <span className="text-[#006847]" data-id="element-6219">14.</span>
              LIMITACIÓN DE RESPONSABILIDAD
            </h2>
            <div className="space-y-4" data-id="element-6220">
              <p data-id="element-6221">En ningún caso NOIZA será responsable por:</p>
              <ul className="list-disc pl-6 space-y-1 text-white/70" data-id="element-6222">
                <li data-id="element-6223">Pérdidas económicas</li>
                <li data-id="element-6224">Daños indirectos</li>
                <li data-id="element-6225">Lucro cesante</li>
                <li data-id="element-6226">Daños reputacionales</li>
              </ul>
            </div>
          </section>

          <section data-id="element-6227">
            <h2 className="text-xl font-bold text-white mb-4 flex items-baseline gap-3" data-id="element-6228">
              <span className="text-[#006847]" data-id="element-6229">15.</span>
              LEGISLACIÓN APLICABLE
            </h2>
            <div className="space-y-4" data-id="element-6230">
              <p data-id="element-6231">
                Estos términos se regirán por la legislación aplicable en Costa
                Rica.
              </p>
            </div>
          </section>

          <section className="bg-white/5 p-6 rounded-2xl border border-white/10 mt-12" data-id="element-6232">
            <h2 className="text-xl font-bold text-white mb-4 flex items-baseline gap-3" data-id="element-6233">
              <span className="text-[#006847]" data-id="element-6234">16.</span>
              ACEPTACIÓN FINAL
            </h2>
            <div className="space-y-4" data-id="element-6235">
              <p className="font-medium" data-id="element-6236">El restaurante declara que:</p>
              <ul className="list-disc pl-6 space-y-2 text-white/80" data-id="element-6237">
                <li data-id="element-6238">Ha leído este documento completo</li>
                <li data-id="element-6239">Comprende su alcance</li>
                <li data-id="element-6240">Acepta todas sus condiciones</li>
              </ul>
            </div>
          </section>
        </div>
      </main>
    </div>;
}